module.exports = __webpack_public_path__ + "static/img/20009 (3).9d4b44a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20009 (3).webp
// module id = 9Ynv
// module chunks = 14